// Job 16: the site header links straight to the entity, and the entity page's
// breadcrumb then said "Back to Clients" — sending a user who came from a site to
// the client list instead of back to their site. The linking page now names where
// it came from, and the destination honours it.
//
// State travels in the browser's history entry, so treat it as untrusted input:
// anything malformed, or any target that isn't an in-app path, falls back.

import { useLocation } from 'react-router-dom';

export type BackTarget = {
  label: string;
  to: string;
};

export type BackTargetState = { from?: BackTarget | null } | null | undefined;

const isInAppPath = (to: string): boolean => to.startsWith('/') && !to.startsWith('//');

export const resolveBackTarget = (state: unknown, fallback: BackTarget): BackTarget => {
  const from = (state as { from?: unknown } | null | undefined)?.from as Partial<BackTarget> | null | undefined;
  if (!from || typeof from.label !== 'string' || typeof from.to !== 'string') return fallback;
  if (!from.label || !isInAppPath(from.to)) return fallback;
  return { label: from.label, to: from.to };
};

/** The breadcrumb target for this page: where the user came from, else `fallback`. */
export const useBackTarget = (fallback: BackTarget): BackTarget =>
  resolveBackTarget(useLocation().state, fallback);
